module.exports = __webpack_public_path__ + "img/img.4330453b.png";